import { useGameStore } from '@/store/gameStore'

// Central coordinator for the blocking, centered modals so they never stack on
// top of each other. They all share ONE priority order; only the highest-
// priority active modal renders, and the rest wait their turn (their trigger
// state persists in the store/component until dismissed, so nothing is lost —
// e.g. you close the "Pista lista" reveal and THEN the weekly report appears).
//
// Priority (highest first):
//   gameResult (game over / victory)
//   storyBeat  (narrative)
//   levelUp    (club level up)
//   construction (works finished reveal)
//   event      (random event decision)
//   report     (weekly report) — lowest; lives in ReportModal's local state, so
//              it isn't ranked here. ReportModal shows only when this is null.
//
// ConfirmDialog (z-index 230) is deliberately excluded: it is user-initiated
// and always sits on top by design.
export type TopModal = 'gameResult' | 'storyBeat' | 'levelUp' | 'construction' | 'event' | null

export function useTopModal(): TopModal {
  const gameResult = useGameStore(s => s.gameResult)
  const resultAcknowledged = useGameStore(s => s.resultAcknowledged)
  const storyBeat = useGameStore(s => s.pendingStoryBeats[0])
  const levelUp = useGameStore(s => s.pendingLevelUp)
  const construction = useGameStore(s => s.pendingConstructionReveals[0])
  const event = useGameStore(s => s.pendingEvent)

  // 'lost' is terminal; 'won' blocks only until it's acknowledged
  if (gameResult === 'lost' || (gameResult === 'won' && !resultAcknowledged)) return 'gameResult'
  // Only modal-presentation beats render a blocking overlay
  if (storyBeat?.modal) return 'storyBeat'
  if (levelUp != null) return 'levelUp'
  if (construction) return 'construction'
  if (event) return 'event'
  return null
}
